<script lang="ts" setup>
const {t} = useI18n();
useSeo({
    title: t('seo.privacy.title'),
    description: t('seo.privacy.description'),
});
const {collectionUri} = useI18nCollection();
const page = await queryCollection(collectionUri('privacypolicy')).first();
</script>

<template>
  <div class="page-container-md">
    <h1 class="page-title text-brand-dark mb-8">{{ page.title }}</h1>
    <ContentRenderer :value="page" class="with-free-text mb-8"/>
  </div>
</template>

<style scoped>

</style>